import { render } from "./PostsDashboard.vue?vue&type=template&id=18edadd3"
import script from "./PostsDashboard.vue?vue&type=script&lang=js"
export * from "./PostsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__